import { useEffect, useState } from "react";
import { api, fmtMoney, fmtDate, today } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { Input } from "@/components/ui/input";

export default function DayBook() {
    const [date, setDate] = useState(today());
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/day-book").then(({ data }) => setItems(data)); }, [date]);

    return (
        <>
            <PageHeader kicker="ACCOUNTING" title="Day Book" subtitle="Chronological list of every transaction posted to the books."
                actions={<Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="w-[140px]" />} />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    <table className="fin-table">
                        <thead><tr><th>Date</th><th>Number</th><th>Source</th><th>Narration</th><th className="num">Amount</th></tr></thead>
                        <tbody>
                            {items.map((j) => (
                                <tr key={j.id}>
                                    <td className="text-[12px] text-muted-foreground">{fmtDate(j.date)}</td>
                                    <td className="font-mono text-[12px]">{j.number}</td>
                                    <td className="capitalize text-[12px]">{j.source.replace("_", " ")}</td>
                                    <td>{j.narration}</td>
                                    <td className="num">{fmtMoney(j.total_debit)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </PageBody>
        </>
    );
}
